  <nb-card *ngIf="!loading && !done" >
           <nb-card-header>
                
 <div style="display:flex; width:100%">
                <span style="margin-right:20px;">Що ви хотіли б поліпшити в сервісі?</span>   
                 <span style="display:flex; margin-left:auto; cursor: pointer;"  (click)="ref.close()">
			<nb-icon [icon]="'close-outline'" pack="eva"></nb-icon>
		</span>  
                </div>
           </nb-card-header>
           	<nb-card-body class="mw">
	 	

			<div>
			
			
				<div>
				
					<textarea  [(ngModel)]="text" style="min-height:180px; resize:none" nbInput fullWidth placeholder="Опис"></textarea>
				
				
				
				
				</div>

				
				<div style="margin-top:10px" class="nv d-flex">
				
					<div style="margin-top:auto; margin-bottom:auto;" class="d-flex">
					
						<input type="file"  (change)="file = $event.target?.files[0] || null" />
					
					</div>
				
					<div style="margin-left:auto;" class="d-flex">
					
						<button status="primary" [disabled]="text.length < 3" (click)="snd()" nbButton>Надіслати</button>

					
					</div>
				
				
				
				
				</div>

			
			</div>

		 
		 
 
        	</nb-card-body> 
 </nb-card> 

  <nb-card *ngIf="done" >
  <nb-card-body> 
  
  <div style="margin-top:10px; min-width:320px" class="nv d-flex">
				
					<div style="margin-top:auto; margin-bottom:auto;" class="d-flex">
					
						<div>Дякуємо за зворотній зв'язок!</div>
					
					</div>
				
					<div style="margin-left:auto;" class="d-flex">
					
						<button (click)="ref.close()" nbButton>OK</button>

					
					</div>
				
				
				
				
				</div>
   </nb-card-body> 
   </nb-card>
 
 
    <div *ngIf="loading" style=" position:fixed; z-index: 7777; width:100%; height:100%; top:0; left: 0; display: flex; ">
    <div style="display: flex; margin: auto;"> 
	 
         <app-loader></app-loader>
     </div>
    </div> 
 
